export class DataHandler {
  protected dataId: string;
  protected runtimeDataCopy: any;
  protected isFirstRun: boolean;

  constructor(dataId: string, defaultData: any) {
    this.dataId = dataId;
    this.runtimeDataCopy = defaultData;
    this.isFirstRun = false;
  }

  get IsFirstRun() {
    return this.isFirstRun;
  }

  public save(data: any) {
    this.runtimeDataCopy = data;
    if (!this.isLocalStorageAvailable()) return;

    window.localStorage.setItem(this.dataId, JSON.stringify(data));
  }

  public load(): any {
    if (!this.isLocalStorageAvailable()) {
      // Return fake or local data.
      return this.runtimeDataCopy;
    }

    let data = window.localStorage.getItem(this.dataId);
    // TODO: Check if data is an object.
    if (data) {
      data = JSON.parse(data);
      this.isFirstRun = false;
    } else {
      this.isFirstRun = true;
    }

    console.log(
      '%c%s%c%s%c%s',
      'background: #2192FF; color: #fff; padding: 2px 5px; border-radius: 5px; margin-right: 8px;',
      'Data Handler',
      'color: #000; padding: 2px;',
      `Is First Run:`,
      'color: #0000ff; padding: 2px;',
      `${this.isFirstRun}`
    );

    return data ?? this.runtimeDataCopy;
  }

  protected isLocalStorageAvailable(): boolean {
    let testData = '0ed4bef58f9f4832adfd264671fb7e8c';

    try {
      window.localStorage.setItem(testData, testData);
      window.localStorage.removeItem(testData);
      return true;
    } catch (error) {
      return false;
    }
  }
}
